export default __webpack_public_path__ + "static/media/emptyAd.ec16e36c.png";